export default function TruckCircle() {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect width='24' height='24' rx='12' fill='#18181B' />
      <path
        d='M14 7H7.33333C6.59695 7 6 7.59695 6 8.33333V14.3333C6 14.7015 6.29848 15 6.66667 15H14M14 7V15M14 7H15.2759C15.5421 7 15.7972 7.10536 15.9854 7.29289L17.7071 9.01462C17.8946 9.20216 18 9.45744 18 9.72394V13.6667C18 14.403 17.403 15 16.6667 15H14M8.33333 16.3333C8.33333 17.0697 8.93029 17.6667 9.66667 17.6667C10.403 17.6667 11 17.0697 11 16.3333C11 15.597 10.403 15 9.66667 15C8.93029 15 8.33333 15.597 8.33333 16.3333ZM15.3333 16.3333C15.3333 17.0697 15.9303 17.6667 16.6667 17.6667C17.403 17.6667 18 17.0697 18 16.3333C18 15.597 17.403 15 16.6667 15C15.9303 15 15.3333 15.597 15.3333 16.3333Z'
        stroke='#A1A1AA'
        strokeWidth='1.25'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
